<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>
    {{ utils.getLangTerm('toolbox-talks.singular', 'Toolbox Talk') }}
    {{ toolbox_talk_template?.template_type?.toLowerCase() === 'snippet' ? 'Snippet' : 'Template' }} Form
  </h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">

  <form #f="ngForm" class="form-container" (ngSubmit)="onSubmit(f)">
    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>{{ (utils.getLangTerm('toolbox-talks.singular', 'Toolbox Talk')) + ' ' + (toolbox_talk_template?.template_type?.toLowerCase() === 'snippet' ? 'Snippet' : 'Template') }}</mat-label>
      <input
        matInput
        [placeholder]="(utils.getLangTerm('toolbox-talks.singular', 'Toolbox Talk')) + ' ' + (toolbox_talk_template?.template_type?.toLowerCase() === 'snippet' ? 'Snippet' : 'Template')"
        [(ngModel)]="toolbox_talk_template.name"
        name="name"
        type="text"
        #name
        required />
      <mat-error *ngIf="!name.valid">
        Please enter the name or subject of the {{ utils.getLangTerm('toolbox-talks.singular', 'Toolbox Talk') }} {{ toolbox_talk_template?.template_type?.toLowerCase() === 'snippet' ? 'Snippet' : 'Template' }}.
      </mat-error>
    </mat-form-field>

    <div class="full-width mb-4">
      <app-rich-text-editor
        [(ngModel)]="toolbox_talk_template.agenda"
        name="toolbox_talks_agenda"
        placeholder="Agenda"
        [height]="350">
      </app-rich-text-editor>
    </div>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic" *ngIf="toolbox_talk_template.id && toolbox_talk_template.creator">
      <mat-label>Created By</mat-label>
      <input
        matInput
        placeholder="Created By"
        [value]="toolbox_talk_template.creator?.contact_person"
        type="text"
        disabled />
    </mat-form-field>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic" *ngIf="toolbox_talk_template.id">
      <mat-label>Created At</mat-label>
      <input
        matInput
        placeholder="Created At"
        [value]="(toolbox_talk_template.date_created * 1000) | timezoneConvertLong"
        type="text"
        disabled />
    </mat-form-field>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic" *ngIf="toolbox_talk_template.id && toolbox_talk_template.updater">
      <mat-label>Last Updated By</mat-label>
      <input
        matInput
        placeholder="Last Updated By"
        [value]="toolbox_talk_template.updater?.contact_person"
        type="text"
        disabled />
    </mat-form-field>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic" *ngIf="toolbox_talk_template.id">
      <mat-label>Last Updated At</mat-label>
      <input
        matInput
        placeholder="Last Updated At"
        [value]="(toolbox_talk_template.date_modified * 1000) | timezoneConvertMedium"
        type="text"
        disabled />
    </mat-form-field>
  </form>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="px-3 py-2">
  <button
    mat-raised-button
    *ngIf="!toolbox_talk_template.id"
    [disabled]="!f.valid || inProgress"
    color="primary"
    (click)="onSubmit(f)"
    class="my-2 ml-1 mr-2"
    type="button">
    <mat-icon>save</mat-icon>
    Save & Close
  </button>

  <button
    mat-raised-button
    *ngIf="toolbox_talk_template.id && canEdit"
    [disabled]="!f.valid || inProgress"
    color="primary"
    (click)="onSubmit(f)"
    class="my-2 ml-1 mr-2"
    type="button">
    <mat-icon>save</mat-icon>
    Save
  </button>

  <button
    mat-raised-button
    *ngIf="toolbox_talk_template.id && canEdit"
    [disabled]="!f.valid || inProgress"
    color="primary"
    (click)="onSubmit(f, true)"
    class="my-2 ml-1 mr-2"
    type="button">
    <mat-icon>save</mat-icon>
    Save & Continue
  </button>

<!--  <app-files-selector (selected)="newFiles = $event" [selectedFilesCount]="newFiles?.length" appMarginRight>-->
<!--  </app-files-selector>-->

<!--  <button mat-raised-button (click)="onRemoveFiles()" color="secondary" [matBadge]="toolbox_talk_template?.files?.length?.toString()"-->
<!--          [disabled]="!toolbox_talk_template?.files?.length" type="button" class="remove-files">-->
<!--    <mat-icon>open_in_browser</mat-icon>-->
<!--    Manage Files-->
<!--  </button>-->

  <button
    mat-raised-button
    color="secondary"
    class="my-2 ml-1 mr-2"
    type="button"
    (click)="onSelectSnippets()">
    <mat-icon>add</mat-icon>
    Add Snippet
  </button>
</mat-dialog-actions>
